<ngx-skeleton-loader
        class="skeleton-loader image"
        [theme]="{
            'height': '70px',
            'width': '70px',
            'background-color': 'var(--skeleton-background-color)',
            'margin-bottom': '0',
            'border-radius': '0'
        }"
></ngx-skeleton-loader>
<div class="body">
    <div class="top-side">
        <div class="code-and-name">
            <ngx-skeleton-loader
                    class="skeleton-loader code"
                    [theme]="{
                        'height': '10px',
                        'width': '59px',
                        'background-color': 'var(--skeleton-background-color)',
                        'margin-bottom': '0'
                    }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
                    class="skeleton-loader name"
                    [theme]="{
                        'height': '16px',
                        'width': '180px',
                        'background-color': 'var(--skeleton-background-color)',
                        'margin-bottom': '0'
                    }"
            ></ngx-skeleton-loader>
        </div>
    </div>
    <div class="bottom-side">
        <div class="units_and_prices">
            <ngx-skeleton-loader
                    class="skeleton-loader units"
                    [theme]="{
                    'height': '12px',
                    'width': '100px',
                    'background-color': 'var(--skeleton-background-color)',
                    'margin-bottom': '0'
                }"
            ></ngx-skeleton-loader>
            <div class="prices">
                <ngx-skeleton-loader
                        class="skeleton-loader price"
                        [theme]="{
                    'height': '16px',
                    'width': '49px',
                    'background-color': 'var(--skeleton-background-color)',
                    'margin-bottom': '0'
                }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                        class="skeleton-loader unit-price"
                        [theme]="{
                    'height': '12px',
                    'width': '49px',
                    'background-color': 'var(--skeleton-background-color)',
                    'margin-bottom': '0'
                }"
                ></ngx-skeleton-loader>
            </div>
        </div>
        <ngx-skeleton-loader
                class="skeleton-loader tile-button"
                [theme]="{
                    'height': '40px',
                    'width': '100%',
                    'background-color': 'var(--skeleton-background-color)',
                    'margin-bottom': '0',
                    'border-radius': '0'
                }"
        ></ngx-skeleton-loader>


    </div>
</div>
